import {mapGetters} from "vuex";
import i18n from "../../locales";

const callParkingSelectMixin = {
    data() {
        return {
            selectedCallParkingNumber: "all"
        }
    },
    computed: {
        ...mapGetters("callParkings", ["callParkings"]),

        callParkingDropdownOptions() {
            const options = this.callParkings.map((callParking) => {
                return {name: callParking.name + ' (' + callParking.first_slot_number + '-' + callParking.last_slot_number + ')', value: callParking.number}
            })

            options.unshift({name: i18n.t("panel.services.call-parking.all"), value: "all"})

            return options
        },

        isAll() {
            return this.selectedCallParkingNumber === "all"
        },

        filteredCallParkings() {
            if (this.isAll) {
                return this.callParkings
            }

            return this.callParkings.filter(callParking => callParking.number === this.selectedCallParkingNumber)
        }
    }
}

export default callParkingSelectMixin